<template>
    <v-card
    max-width="700px">
        <v-btn
            class="open-help"
            icon
            dark
            @click="$emit('close', false)"
        >
            <v-icon :color="$mainColor">mdi-close</v-icon>
        </v-btn>
        <v-card-text>
            <div class="render-container d-flex justify-space-between align-start">
                <!--div class="render-container__sidebar">
                    <h2>Choose a template</h2>
                    <v-text-field
                        v-model="search"
                        label="Search"
                        @input="$emit('search', search)"
                    ></v-text-field>
                    <v-list>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-subtitle>All templates</v-list-item-subtitle>
                                <v-list-item-subtitle>Recent</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <h3>CATEGORIES</h3>
                                </v-list-item-title>
                                <v-list-item-subtitle>All templates</v-list-item-subtitle>
                                <v-list-item-subtitle>Recent</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </div-->
                <div class="render-container__content d-flex justify-space-between align-start flex-wrap">
                    <div>
                        <component :is="name"></component>
                    </div>
                </div>
            </div>
        </v-card-text>
    </v-card>
    
</template>
<script>
import user from '../help/user'
import statistic from '../help/statistic'
import proposal from '../help/proposal'
import personalData from '../help/personalData'
import newProposal from '../help/newProposal'
import moderator from '../help/moderator'
import expert from '../help/expert'
import calendar from '../help/calendar'
import bs from '../help/bs'
import registration from '../help/Registration'

export default {
    name: 'WidgetsRenderFileLayouts',
    props: {
        name: String
    },
    data() {
        return {
            search: '',
            text: ''
        }
    },
    components: {
        user,
        statistic,
        proposal,
        personalData,
        registration,
        bs,
        expert,
        moderator,
        calendar,
        newProposal
    },
}
</script>
<style scoped>
.render-container__sidebar {
    margin-top: 48px;
    width: 20%;
    min-height: 1px;
    max-height: 900px;
    overflow: hidden;
}
.render-container__content {
    width: 100%;
    font-size:20px;
    font-weight: bold;
}
.render-container__content img{
        
    max-width: 800px !important;
}

</style>